/* eslint-disable import/prefer-default-export */
export const AVAILABLE_SLOTS = [
  { label: 'Morning', value: 'morning' },
  { label: 'Afternoon', value: 'afternoon' },
  { label: 'Evening', value: 'evening' }
];

export const CAT_PERCENTILE_PREDICTOR_DEFAULT_META = {
  title: 'CAT Percentile Predictor - Unacademy',
  description:
    'Unacademy’s CAT percentile predictor 2025 is designed to help you predict your most accurate percentile basis your CAT 2025 score. Enter your CAT 2025 marks to get predicted percentile'
};

export const PREDICTOR_POINTS = [
  'Get CAT 2025 percentile based on your section-wise scores',
  'Talk to our CAT academic counsellor for a personalised study plan',
  'Get free CAT 2025 detailed video solutions'
];
